module.exports = __webpack_public_path__ + "img/score-star.e4e01616.svg";